import { NotFound } from '@meteor/pages';
import { ModalRoot, Toaster } from '@meteor/ui';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { CheckoutHome } from './pages';
import { RouterErrorPage } from './pages/_error/routerError';

let router = createBrowserRouter([
  {
    path: '/',
    element: (
      <>
        <Outlet />
        <Toaster />
        <ModalRoot />
      </>
    ),
    errorElement: <RouterErrorPage />,
    children: [
      {
        path: '',
        element: <CheckoutHome />
      }
    ]
  }
]);

export let App = () => {
  return <RouterProvider router={router} fallbackElement={<NotFound />} />;
};
